export const DEFAULT_LANGUAGE = 'ro';

export const localeManifest = Object.freeze({
  ro: Object.freeze({
    code: 'ro',
    locale: 'ro-RO',
    direction: 'ltr',
    nativeName: 'Română',
  }),
  en: Object.freeze({
    code: 'en',
    locale: 'en-GB',
    direction: 'ltr',
    nativeName: 'English',
  }),
});

export const SUPPORTED_LANGUAGE_CODES = Object.freeze(Object.keys(localeManifest));

export const normalizeLanguageCode = (value) => {
  if (typeof value !== 'string') return null;
  const primaryCode = value.trim().toLowerCase().replace('_', '-').split('-')[0];
  return Object.prototype.hasOwnProperty.call(localeManifest, primaryCode) ? primaryCode : null;
};

export const isSupportedLanguage = (value) => normalizeLanguageCode(value) !== null;

export const resolveLanguage = (value, fallback = DEFAULT_LANGUAGE) => (
  normalizeLanguageCode(value)
  || normalizeLanguageCode(fallback)
  || DEFAULT_LANGUAGE
);

export const getLocaleDefinition = (language) => localeManifest[resolveLanguage(language)];

export const getLocale = (language) => getLocaleDefinition(language).locale;

export const getTextDirection = (language) => getLocaleDefinition(language).direction;

export const getSupportedLanguageOptions = () => SUPPORTED_LANGUAGE_CODES.map((code) => ({
  code,
  native_name: localeManifest[code].nativeName,
}));

export const filterSupportedLanguages = (languages = []) => {
  if (!Array.isArray(languages)) return [];

  const seen = new Set();
  return languages.reduce((result, language) => {
    const code = normalizeLanguageCode(language?.code);
    if (!code || seen.has(code)) return result;

    seen.add(code);
    result.push({
      ...language,
      code,
      native_name: language.native_name || localeManifest[code].nativeName,
    });
    return result;
  }, []);
};

export const syncDocumentLocale = (language, documentRef = globalThis.document) => {
  if (!documentRef?.documentElement) return;
  const definition = getLocaleDefinition(language);
  documentRef.documentElement.lang = definition.code;
  documentRef.documentElement.dir = definition.direction;
};
